import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import aviso from '../views/Aviso.vue'
import ayuda from '../views/ayuda.vue'
// import loan from "../views/loan.vue"

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/home',
	},
	{
		path: '/home',
		name: 'home',
		component: home,
	},

	{
		path: '/notice',
		name: 'notice',
		component: aviso,
	},
	{
		path: '/help',
		name: 'help',
		component: ayuda,
	},
	// {
	//   path: '/loan',
	//   name: 'loan',
	//   component: loan
	// },
]

const router = new VueRouter({
	mode: location.href.indexOf('//www.dinerbacano.co') >= 0 ? 'history' : 'hash',
	base: process.env.BASE_URL,
	routes,
})

export default router
